import * as bowser from 'bowser';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';
import * as Raven from 'raven-js';

// interface BrowserSupportData {
//   browser: typeof bowser.name;
//   browserVersion: typeof bowser.version;
//   error: { code?: string; message?: string };
//   os: typeof bowser.osname;
//   osVersion: typeof bowser.osversion;
// }

const config = {
  apiKey: 'AIzaSyCJfKcc_OyA0rv-jA9yH_HC7PDi8PylfCc',
  authDomain: 'just-in-north.firebaseapp.com',
  databaseURL: 'https://just-in-north.firebaseio.com',
  messagingSenderId: '581547763015',
  projectId: 'just-in-north',
  storageBucket: 'just-in-north.appspot.com',
};

firebase.initializeApp(config);

export const Timestamp = firebase.firestore.Timestamp;

export const firestore = firebase.firestore();
firestore.settings({ timestampsInSnapshots: true });

const updateBrowserSupportCollection = (data) => {
  const { browser, browserVersion, os, osVersion } = data;

  firestore
    .collection('browserSupport')
    .doc(`${os}-${osVersion}:${browser}-${browserVersion}`)
    .set({ browser, browserVersion, os, osVersion })
    .catch(error => {
      Raven.captureException(error, {
        extra: { browserSupportData: { ...data } },
      });
    });
};

// const handlePersistence = () => {
//   const supportsPersistence = (() => bowser.check({ ios: '10.3' }))();

//   if (supportsPersistence) {
//     firestore
//       .enablePersistence({ experimentalTabSynchronization: true })
//       .catch(error => {
//         // const browserSupportData = {
//         //   browser: bowser.name,
//         //   browserVersion: bowser.version,
//         //   error: { code: error.code, message: error.message },
//         //   os: bowser.osname,
//         //   osVersion: bowser.osversion,
//         // };

//         Raven.captureException(
//           "Browser doesn't support Firestore persistence",
//           // { extra: { browserSupportData } },
//         );

//         // updateBrowserSupportCollection(browserSupportData);
//       });
//   }
// };

// handlePersistence();

export const storage = firebase.storage();

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.ts